<app-custom-loader *ngIf="loading"></app-custom-loader>
<router-outlet (activate)="changeOfRoutes()" #outlet="outlet" *ngIf="!loading"></router-outlet>

<ng-container *ngIf="notificationsArray && notificationsArray.length > 0">
  <app-notifications [items]="notificationsArray"></app-notifications>
</ng-container>


<!-- SCHOOL SWITCHER -->
<div class="agentSettings" *ngIf="schools && schools.length > 0 && currentUser && currentUser.isGhost">
  <div *ngIf="!settingsOpen" (click)="toggleSettings()" class="closed position-fixed bg-primary text-white text-center pointer">
    <i class="fa fa-cog v-middle" aria-hidden="true"></i>
  </div>
  <div *ngIf="settingsOpen" class="open position-fixed bg-primary text-white text-start pointer">
    <div class="row">
      <i (click)="toggleSettings()" class="fa fa-chevron-right col-2 v-middle" aria-hidden="true"></i>
      <div class="form-group col-9">
        <select class="form-control font-16 v-middle border-0 shadow-none" (change)="chooseSchool($event.target.value)">
          <option>Choix de la nouvelle école</option>
          <option *ngFor="let schoolItem of schools;trackBy:trackById" value="{{schoolItem.id}}">
            {{schoolItem.name}}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>
